export default "__VITE_ASSET__ChzzSIgd__"